import * as React from "react";

type SidebarCollapseContextValue = {
  collapsed: boolean;
};

export const SidebarCollapseContext =
  React.createContext<SidebarCollapseContextValue>({
    collapsed: false,
  });

export function useSidebarCollapsed() {
  return React.useContext(SidebarCollapseContext).collapsed;
}

interface SidebarNavProps {
  children: React.ReactNode;
  collapsed: boolean;
  className?: string;
}

export function SidebarNav({
  children,
  collapsed,
  className,
}: SidebarNavProps) {
  return (
    <SidebarCollapseContext.Provider value={{ collapsed }}>
      <nav className={className}>{children}</nav>
    </SidebarCollapseContext.Provider>
  );
}
